module.exports = __webpack_public_path__ + "img/ramen.4ce0dbe.png";